import PurchaseModalController from 'utils/purchase_modal/purchase_modal_component/purchase-modal-controller';

export default class FreeTrialUpgradeModalController extends PurchaseModalController {
  static targets = [
    'formSubmitBtn',
  ];

  declare formSubmitBtnTarget: HTMLButtonElement;

  lockForm() {
    this.formSubmitBtnTarget.classList.add('is-loading');
  }

  unlockForm() {
    this.formSubmitBtnTarget.classList.remove('is-loading');
  }
}
